import { OdataFilters, queryCollection } from "helpers/reqparams";
import { body, request } from "services/request";

const resource = "api/counterpartiesInsolvencyRegistry";

const listQuery = { orderby: ["id desc"] };

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...listQuery });
    return request(`${resource}/getDetailed${query}`, { method: "GET" }, { countInHeaders: true });
};

const getOrganizationSuggestions = (address: string) =>
    request(`${resource}/getOrganizationSuggestions`, body({ address, count: 5 }));
const getItem = (inn: string) => request(`${resource}/get/${inn}`, { method: "GET" });

export { index, getOrganizationSuggestions, getItem };
